import { render, staticRenderFns } from "./todoDetailsTask.vue?vue&type=template&id=e9b72c46&"
import script from "./todoDetailsTask.vue?vue&type=script&lang=js&"
export * from "./todoDetailsTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports